import { createFileRoute } from '@tanstack/react-router';
import { CampaignsTestForward } from '@/pages/workspaces/automations/[campaignId]/tests/routing';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/tests/$actionId',
)({
  component: CampaignsTestForward,
});
